import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { type ChipMultipleSelectionProps, ChipMultipleSelection } from '../ChipMultipleSelection';

type FormChipMultipleSelectionProps<TFieldValues extends FieldValues> =
  UseControllerProps<TFieldValues> & ChipMultipleSelectionProps;

function FormChipMultipleSelection<TFieldValues extends FieldValues = FieldValues>(
  props: FormChipMultipleSelectionProps<TFieldValues>,
) {
  const {
    field,
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <ChipMultipleSelection
      {...props}
      {...field}
      error={!!error}
      required={!!props.rules?.required}
      helperText={error?.message ?? props.helperText ?? ''}
    />
  );
}

export type { FormChipMultipleSelectionProps };
export { FormChipMultipleSelection };
